import { useState } from 'react';
import { IconButton, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { faTrashCan, faUsersRays } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { UserTable } from '../components/user-table/user-table';
import { useDeleteSeatMutation } from '../corporate.slice';
import { CompanySubscriberItems, CorporateProps, SubscribersProps } from '../corporate.types';
import { DeleteUserModal } from '../components/delete-user-modal';
export const Subscribers = ({
  companyDetails,
  subscriberData,
  setFeedbackParams,
  feedbackParams,
  companyTrial,
  totalUsersCount
}: SubscribersProps) => {
  const [deleteSeat, {
    isLoading
  }] = useDeleteSeatMutation();
  const [modalOpen, setModalOpen] = useState(false);
  const [seatId, setSeatId] = useState('');
  const handleSeatDelete = async () => {
    try {
      await deleteSeat({
        companyId: companyDetails._id,
        seatId
      }).unwrap();
      NotificationDispatch('success', 'Seat deleted successfully');
    } catch (error) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
  };
  const columns: CorporateProps<CompanySubscriberItems>['columns'] = [{
    key: 'email',
    title: 'Email',
    sortFunction: () => null,
    flex: '0 0 32%',
    alignItems: 'flex-start'
  }, {
    key: 'id',
    title: 'Seat ID',
    sortFunction: () => null,
    flex: '0 0 18%'
  }, {
    key: 'added',
    title: 'Start Date',
    sortFunction: () => null,
    flex: '0 0 18%'
  }, {
    key: 'subExpiry',
    title: 'Expiry Date',
    sortFunction: () => null,
    flex: '0 0 22%',
    alignItems: 'flex-start'
  }, {
    key: '_id',
    title: 'Action',
    width: '10rem',
    flex: '0 0 10%',
    justifyContent: 'center',
    render: item => <IconButton variant="delete" width="4rem" height="4rem" aria-label="action" onClick={() => {
      setSeatId((item as string));
      setModalOpen(true);
    }}>
          <FontAwesomeIcon icon={faTrashCan} size="lg" />
        </IconButton>
  }];
  return <>
      <DeleteUserModal isModalOpen={modalOpen} isLoading={isLoading} title="Remove seat" description="Are you sure you want to remove this seat?" deleteButtonText="Remove seat" onModalOpen={setModalOpen} onDeleteUser={handleSeatDelete} data-sentry-element="DeleteUserModal" data-sentry-source-file="subscribers.tsx" />
      <UserTable title="Seats" isSubscriber data={subscriberData} columns={columns} companyDetails={companyDetails} icon={faUsersRays} setFeedbackParams={setFeedbackParams} feedbackParams={feedbackParams} companyTrial={companyTrial} totalUsersCount={totalUsersCount} data-sentry-element="UserTable" data-sentry-source-file="subscribers.tsx" />
    </>;
};